/** Allocation Monitor (user, 2026-10-14): every test job, its holder and progress. */
import { QC_JOB_STAGES, QC_JOB_STATUSES, QC_TEST_KINDS } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { AllocationMonitorPage } from "@/features/quality/components/allocation/allocation-monitor-page";

const search = z.object({
  view: z.enum(["jobs", "analysts", "srfs"]).default("jobs").catch("jobs"),
  status: z.enum(QC_JOB_STATUSES).optional().catch(undefined),
  stage: z.enum(QC_JOB_STAGES).optional().catch(undefined),
  test: z.enum(QC_TEST_KINDS).optional().catch(undefined),
  analystId: z.number().int().positive().optional().catch(undefined),
  crop: z.string().optional(),
  varietyId: z.number().int().positive().optional().catch(undefined),
  stageId: z.number().int().positive().optional().catch(undefined),
  lot: z.string().optional(),
  srfNo: z.string().optional(),
  q: z.string().optional(),
  retest: z.boolean().optional().catch(undefined),
  finished: z.boolean().optional().catch(undefined),
  from: z.string().optional(),
  to: z.string().optional(),
  page: z.number().int().min(1).default(1).catch(1),
});

export const Route = createFileRoute("/_app/quality/allocation/monitor")({
  validateSearch: search,
  beforeLoad: () => {
    // Read-only for QA roles that do not allocate (qc.allocation_view).
    const { can } = useAuth.getState();
    if (!can("qc.allocate") && !can("qc.allocation_view"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AllocationMonitorPage
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
